import React from 'react';
import { useParams } from 'react-router-dom';
import InvitationAcceptance from './InvitationAcceptance';
import { logger } from '../utils/logger';

const InvitationPage = () => {
  const { token } = useParams();

  const handleSuccess = (result) => {
    logger.info('Invitation accepted successfully:', result);
    // Redirect to home after a short delay
    setTimeout(() => {
      window.location.hash = '/';
    }, 2000);
  };

  const handleError = (error) => {
    logger.error('Invitation error:', error);
  };

  return <InvitationAcceptance token={token} onSuccess={handleSuccess} onError={handleError} />;
};

export default InvitationPage;
